

































































































































































































































import {
  Component,
  PropSync,
  Prop,
  Vue,
  Watch,
  Ref,
} from "vue-property-decorator";
import {
  ReservationModel,
  ReservationAccUnitModel,
  UnitAvailability,
  SearchRestrictionsModel,
  AddOnServiceModel,
  DistributionChannelTypesEnum,
  NotifyUnitEvent,
  SelectedRatePlanModel,
} from "./types";
import {
  calculateAddOnServiceQuantity,
  getUnitOwnerIds,
  calculateAgencyFees,
} from "./functions";
import { AvailabilitySearchPrefillModel } from "@/components/advanced-search/types";
import ReservationFormUnitTile from "./ReservationFormUnitTile.vue";
import ReservationFormUnitTileMobile from "./ReservationFormUnitTileMobile.vue";
import ReservationFormUnitForm from "./ReservationFormUnitForm.vue";
import { Action, Getter } from "vuex-class";
import AvailabilitySearchReservationForm from "@/components/advanced-search/AvailabilitySearchReservationForm.vue";
import {
  SelectedAvailability,
  SimpleAvailabilitySearchResult,
} from "@/shared/models/availability";
import { PriceCalculationMethodView } from "@/shared/models/priceCalculationMethods";
import { TaxRateView } from "@/shared/models/taxRates";
import { ListModel } from "@/shared/models/listModel";
import FormDescription from "@/components/misc/FormDescription.vue";
import CopyGuestsDialog from "./copy-guests/CopyGuestsDialog.vue";
import * as _ from "lodash";
import { SalesChannelView } from "@/shared/models/salesChannel";
import { CustomerModel } from "@/shared/models/vCustomer";
import { AppParam, AppParamsEnum } from "@/shared/models/appParam";
import { ServiceType } from "@/shared/models/serviceType";
import { FinancialSettingsType } from "@/store/modules/financial";
import { differenceInDays } from "@/shared/dateFormatUtils";
import {
  CurrencyConversionService,
  currencyConversionServiceFactory,
} from "@/shared/currencyConversionService";
import SimpleAvailabilitySearchModal from "@/components/advanced-search/SimpleAvailabilitySearchModal.vue";
import SimpleAvailabilitySearchModalMobile from "@/components/advanced-search/SimpleAvailabilitySearchModalMobile.vue";
import { AccomodationUnitStatus } from "@/shared/models/accomodationUnitStatus";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";
import { DistributionChannelEnum } from "@/shared/models/enums.type";
import { round } from "@/components/numbers/numberFormatUtils";

export interface AddUnitModel {
  accomodationUnitTypeId: number;
  accomodationUnitId?: number;
  ratePlanId?: number;
  ratePlansAccomodationUnitTypeId?: number;
  distributionChannelTypeId: number | null;
  channelId: number | null;
  currencyId: number | null;
  arrivalDate: Date | null;
  departureDate: Date | null;
}

@Component({
  components: {
    ReservationFormUnitTile,
    ReservationFormUnitTileMobile,
    ReservationFormUnitForm,
    AvailabilitySearchReservationForm,
    FormDescription,
    CopyGuestsDialog,
    SimpleAvailabilitySearchModal,
    SimpleAvailabilitySearchModalMobile,
  },
})
export default class ReservationFormUnits extends Vue {
  @PropSync("reservation") model?: ReservationModel;

  @Prop({ default: undefined }) availabilities?: SelectedAvailability[];
  @Prop({ default: undefined }) restrictions?: SearchRestrictionsModel;

  @Prop() isMobile?: boolean;

  @Getter("auth/claims") claims?: JwtClaims;

  @Getter("appParams/appParams") appParams?: AppParam[];

  get tenantUsesServiceType() {
    const param = this.appParams?.find(
      (x) => x.id == AppParamsEnum.ReservationTenantUsesServiceTypes
    );
    return param && param.value;
  }

  get calculateWithEVisitorDates() {
    const param = this.appParams?.find(
      (x) =>
        x.id == AppParamsEnum.ReservationEVisitorCalculateCTWithEVisitorDates
    );
    return param && param.value;
  }

  editFormOpen = false;
  unitToEdit: ReservationAccUnitModel | null = null;

  copyGuestsOpen = false;
  copyGuestsToUnitId: number | null = null;

  unitAvailabilities: UnitAvailability[] = [];

  isOverbooked: number[] = [];

  isNotAvailable: number[] = [];

  descriptionTextResource = "ReservationForm.AddUnit.Alert";

  unitSelectionModalOpen = false;

  // list of all possible owner IDs
  get ownerIdsForUnitSelection() {
    if (
      this.model?.distributionChannelTypeId !==
      DistributionChannelEnum.OwnersReservation
    )
      return [];
    return _.uniq(
      this.model?.accomodationUnitTypes.flatMap((x) => getUnitOwnerIds(x)) ?? []
    );
  }

  // add preselected units
  @Watch("availabilities", { immediate: true })
  availabilitiesChanged() {
    if (this.availabilities && this.availabilities.length > 0) {
      this.addAvailabilities(this.availabilities);
    } else {
      if (this.model) {
        this.model.accomodationUnitTypes = [];
      }
    }
  }

  @Watch("restrictions.isFromCalendar")
  async changeCustomerForCalendarRatePlan() {
    if (
      this.model &&
      this.availabilities &&
      this.restrictions &&
      this.availabilities.length > 0 &&
      !this.availabilities.some(
        (x) =>
          x.ratePlansAccomodationUnitTypeId !=
          _.first(this.availabilities)?.ratePlansAccomodationUnitTypeId
      )
    ) {
      const availability = this.availabilities[0];
      const ratePlanId = this.model.accomodationUnitTypes.find(
        (x) => x.accomodationUnitTypeId == availability.accomodationUnitTypeId
      )?.ratePlan?.id;
      const correspondigSalesChannel = this.salesChannels?.find((x) =>
        ratePlanId != undefined ? x.defaultRatePlanId == ratePlanId : undefined
      );
      if (
        correspondigSalesChannel &&
        correspondigSalesChannel?.defaultCustomerId
      ) {
        const id = correspondigSalesChannel.defaultCustomerId;
        await this.axios
          .get<CustomerModel>("/customers/" + id)
          .then((res) => {
            if (this.model) {
              this.model.customerId = res.data.id;
              this.model.customer.id = res.data.id;
              this.model.customer.name = res.data.legalEntityName
                ? res.data.legalEntityName
                : "";
              this.model.customer.eMail = res.data.eMail ? res.data.eMail : "";
              this.model.customer.telephoneNumber = res.data.telephoneNumber
                ? res.data.telephoneNumber
                : "";
              this.model.customer.countryOfResidenceId = res.data
                .countryOfResidenceId
                ? res.data.countryOfResidenceId
                : 0;
              this.model.distributionChannelTypeId =
                DistributionChannelTypesEnum.PartnerAgency;
              this.model.salesChannelId = correspondigSalesChannel.id;
            }
          })
          .finally();
      }
    }
  }

  // combine stay period and units for easier detection of changes
  get stayPeriodAndUnits() {
    return {
      arrivalDate: this.model?.arrivalDate,
      departureDate: this.model?.departureDate,
      units: this.model?.accomodationUnitTypes,
    };
  }

  // check availabilities when period or units change
  @Watch("stayPeriodAndUnits")
  async stayPeriodAndUnitsChanged() {
    if (
      this.stayPeriodAndUnits.arrivalDate &&
      this.stayPeriodAndUnits.departureDate
    ) {
      if (this.model && this.model.id === 0) {
        await this.checkAvailability();
      } else {
        this.isNotAvailable = [];
      }
      await this.checkOverbooking();
      this.getUnitsDayPrices();
    }
  }

  currencyConversionService?: CurrencyConversionService;
  async created() {
    const promises = [];

    if (!this.financialSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }
    if (
      (this.priceCalculationMethods?.length ?? 0) === 0 &&
      this.refreshPriceCalculationMethods
    ) {
      promises.push(this.refreshPriceCalculationMethods());
    }
    if ((this.taxRates?.length ?? 0) === 0 && this.refreshTaxRates) {
      promises.push(this.refreshTaxRates());
    }
    if ((this.salesChannels?.length ?? 0) === 0 && this.refreshSalesChannels) {
      promises.push(this.refreshSalesChannels());
    }
    if ((this.serviceTypes?.length ?? 0) === 0 && this.refreshServiceTypes) {
      promises.push(this.refreshServiceTypes());
    }
    if (
      (this.accomodationUnitStatuses?.length ?? 0) === 0 &&
      this.refreshAccomodationUnitStatuses
    ) {
      promises.push(this.refreshAccomodationUnitStatuses());
    }

    await Promise.all(promises);

    if (this.financialSettings) {
      this.currencyConversionService = currencyConversionServiceFactory(
        this.financialSettings
      );
    }
  }

  get isAllowedToAddUnitsViaAvailabilitySearch() {
    return policyChecker("GLOBAL_AVAILABILITY_SEARCH")(this.claims);
  }

  get reservationIsReadonly() {
    if (
      (policyChecker("OWNER_LEVEL_3")(this.claims) &&
        this.model?.distributionChannelTypeId ===
          DistributionChannelEnum.OwnersReservation) ||
      !policyChecker("OWNER_LEVEL_3")(this.claims)
    ) {
      return false;
    }
    return true;
  }

  closeSearch() {
    if (this.isMobile && this.availabilitySearchRestrictions !== null) {
      this.addAvailabilities(
        this.availabilitySearchSelection,
        this.availabilitySearchRestrictions
      );
    } else {
      this.availabilitySearchOpen = false;
    }
  }

  @Ref("unitForm") unitForm?: ReservationFormUnitForm;

  changeServiceTypes(event: any) {
    this.unitToEdit = event.model;
    if (event.updateOtherUnits) {
      const serviceTypeId = _.first(this.unitToEdit?.dayPrices)?.serviceTypeId;
      this.model?.accomodationUnitTypes
        .filter((x) => x.id !== this.unitToEdit?.id || x.id === 0)
        .forEach((unit) => {
          const currentPriceIncludeCityTax =
            this.serviceTypes?.find((x) => x.id == serviceTypeId)
              ?.includesCityTax ?? false;
          unit.dayPrices.forEach((x) => {
            x.serviceTypeId = serviceTypeId;
            x.price =
              x.price -
              this.mergedCityTaxPricePerDay(unit, currentPriceIncludeCityTax) +
              (x.mergedCityTaxAmount ?? 0);
            x.mergedCityTaxAmount = this.mergedCityTaxPricePerDay(
              unit,
              currentPriceIncludeCityTax
            );
          });
        });
    }
    this.unitChangesSaved();
  }

  async notifyUnitForm(unit: NotifyUnitEvent) {
    this.unitToEdit = unit.model;
    if (unit.updateOtherUnits) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        timeout: 30000,
        message: this.$t("Reservation.RecalculatePrices"),
        actions: [
          {
            text: this.$t("Yes"),
            fun: async () => {
              this.calculateMultipleUnits(
                this.unitToEdit?.ratePlan?.id
                  ? this.unitToEdit.ratePlan.id
                  : null,
                true,
                unit.inputPriceRecalculationOnly
              );
              return true;
            },
          },
          {
            text: this.$t("No"),
            fun: () => {
              this.calculateMultipleUnits(
                this.unitToEdit?.ratePlan?.id
                  ? this.unitToEdit.ratePlan.id
                  : null,
                false,
                unit.inputPriceRecalculationOnly
              );
              return true;
            },
          },
        ],
      });

      return;
    }

    if (this.unitToEdit.ratePlan?.id) {
      this.unitForm?.setRatePlan(
        this.unitToEdit.ratePlan.ratePlansAccomodationUnitTypeId,
        unit.model,
        true,
        false,
        null,
        unit.autoPriceRecalculation,
        unit.inputPriceRecalculationOnly
      );
    }
  }

  //for salesChannelChange
  @Watch("model.isManualSalesChannelChanged")
  changeRatePlanForSalesChannelChange() {
    if (this.model?.isManualSalesChannelChanged) {
      this.model.isManualSalesChannelChanged = false;
      const pickedSalesChannel = this.salesChannels?.find(
        (x) => x.id == this.model?.salesChannelId
      );
      if (pickedSalesChannel?.defaultRatePlanId) {
        this.calculateMultipleUnits(
          pickedSalesChannel.defaultRatePlanId,
          true,
          false
        );
      }
    }
  }

  calculateMultipleUnits(
    ratePlanId: number | null,
    recalculatePrices = false,
    inputPriceRecalculationOnly: boolean
  ) {
    if (ratePlanId === null) {
      return;
    }

    const originalCount = this.model?.accomodationUnitTypes.length ?? 0;
    let changedCount = 0;

    if (ratePlanId) {
      const specialOfferServices = this.getSpecialOfferServices(ratePlanId);

      this.model?.accomodationUnitTypes.forEach((unit) => {
        const ratePlanMappings = unit.ratePlanOptions.filter(
          (e) => e.ratePlanId == ratePlanId && e.status
        );
        if (ratePlanMappings.length > 0) {
          const numberOfPeople =
            unit.numberOfAdults +
            (this.childrenAffectPAXRatePlanSelection
              ? unit.numberOfChildren
              : 0);

          let matchingMapping = ratePlanMappings.find(
            (e) =>
              e.minPersons <= numberOfPeople &&
              e.maxPersons >= numberOfPeople &&
              e.minStay <= unit.numberOfNights &&
              (e.maxStay >= unit.numberOfNights || e.maxStay === 0)
          );
          if (!matchingMapping)
            matchingMapping = ratePlanMappings.find((e) => e.isDefault);

          if (matchingMapping) {
            unit.ratePlan = {
              id: matchingMapping.ratePlanId,
              ratePlansAccomodationUnitTypeId: matchingMapping.id,
              name: matchingMapping.name,
              parentRatePlanId: matchingMapping.parentRatePlanId,
              currencyId: matchingMapping.currencyId,
              isDefault: matchingMapping.isDefault,
              accomodationBookingFee: matchingMapping.accomodationBookingFee,
              addOnServicesBookingFee: matchingMapping.addOnServicesBookingFee,
              mergeAllBookingFeesIntoSingleItem:
                matchingMapping.mergeAllBookingFeesIntoSingleItem,
            } as SelectedRatePlanModel;

            this.unitForm?.setRatePlan(
              matchingMapping.id,
              unit,
              false,
              true,
              specialOfferServices
            );
            if (recalculatePrices) {
              this.unitForm?.recalculatePrices(
                matchingMapping.id,
                unit,
                inputPriceRecalculationOnly
              );
            }

            changedCount++;
          }
        }
      });
    }

    if (changedCount < originalCount) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t("Reservation.Units.RatePlan.UpdateAll.InfoMessage"),
        timeout: 5000,
      });
    }
  }

  getSpecialOfferServices(ratePlanId: number) {
    let services: AddOnServiceModel[] = [];

    Vue.axios
      .get<ListModel<AddOnServiceModel>>(
        `reservations/GetSpecialOfferServices/${ratePlanId}`
      )
      .then((res) => {
        res.data.result.forEach((x) => (x.decimalQuantity = x.defaultQuantity));

        services = res.data.result;
      });

    return services;
  }

  // unit editing
  editUnit(unit: ReservationAccUnitModel) {
    this.unitToEdit = unit;
    this.editFormOpen = true;
  }

  unitChangesSaved() {
    if (this.unitToEdit) {
      const editedIdx =
        this.model?.accomodationUnitTypes.indexOf(this.unitToEdit) ?? -1;
      if (editedIdx > -1) {
        const freshUnitInstance = Object.assign(
          new ReservationAccUnitModel(),
          this.unitToEdit
        );
        this.model?.accomodationUnitTypes.splice(
          editedIdx,
          1,
          freshUnitInstance
        );
      }
    }

    this.$emit("stayPeriodChanged");
  }

  deleteUnit(unit: ReservationAccUnitModel) {
    this.$store.dispatch("showNotification", {
      id: unit.id,
      color: "warning",
      timeout: 10000,
      message: this.$t("ReservationAccomodationUnitType.DeleteConfirmation", {
        value: unit.accomodationUnitName,
      }),
      actions: [
        {
          text: this.$t("Yes"),
          fun: () => {
            if (this.model) {
              const index = this.model.accomodationUnitTypes.findIndex(
                (x) => x === unit
              );
              if (index != -1) {
                this.model.accomodationUnitTypes.splice(index, 1);
              }
            }
            return true;
          },
        },
        {
          text: this.$t("No"),
          fun: () => {
            return true;
          },
        },
      ],
    });

    this.stayPeriodChanged();
  }

  get periodSet() {
    return this.model?.arrivalDate && this.model?.departureDate;
  }

  // get prefil data for availability search
  get availabilitySearchPrefil() {
    const period = [] as Date[];
    if (this.model && this.model.arrivalDate && this.model.departureDate) {
      period.push(this.model.arrivalDate, this.model.departureDate);
    }

    const allocatedAdults =
      this.model?.accomodationUnitTypes.reduce(
        (sum, x) => sum + x.numberOfAdults,
        0
      ) ?? 0;
    const allocatedChildren =
      this.model?.accomodationUnitTypes.reduce(
        (sum, x) => sum + x.numberOfChildren,
        0
      ) ?? 0;
    const allocatedUnits = this.model?.accomodationUnitTypes.length ?? 0;
    const allocatedChildrenAges =
      this.model?.accomodationUnitTypes.reduce(
        (sum, x) => sum + x.childrenAges.length,
        0
      ) ?? 0;
    const numOfUnits = this.preventLessThanZero(
      (this.model?.numberOfUnits ?? 0) - allocatedUnits
    );

    const prefill: AvailabilitySearchPrefillModel = {
      period: period,
      numberOfAdults: this.preventLessThanZero(
        (this.model?.numberOfAdults ?? 0) - allocatedAdults
      ),
      numberOfChildren: this.preventLessThanZero(
        (this.model?.numberOfChildren ?? 0) - allocatedChildren
      ),
      numberOfUnits: numOfUnits == 0 ? 1 : numOfUnits,
      childrenAges: this.model?.childrenAges?.slice(allocatedChildrenAges),
    };

    return prefill;
  }

  preventLessThanZero(number: number) {
    return number < 0 ? 0 : number;
  }

  get unitSelectionFilter() {
    return {
      propertyName:
        this.model?.accomodationUnitTypes[0]?.propertyName ??
        this.model?.originalUnitTypesReservationWasOpenedWith[0]
          ?.propertyName ??
        "",
      arrivalDate: this.model?.arrivalDate,
      departureDate: this.model?.departureDate,
    };
  }

  get selectedUnitIds() {
    return this.model?.accomodationUnitTypes
      .filter((x) => x.accomodationUnitId != undefined)
      .map((x) => x.accomodationUnitId);
  }

  // set units currently on reservation as taken availabilities
  // to display data correctly on availability search
  get takenAvailabilities() {
    let toReturn = [] as SelectedAvailability[];
    const searchArrivalDate = this.model?.arrivalDate
      ?.toISOString()
      .substring(0, 10);
    const searchDepartureDate = this.model?.departureDate
      ?.toISOString()
      .substring(0, 10);

    if (!searchArrivalDate || !searchDepartureDate) {
      return toReturn;
    }

    if (this.model) {
      toReturn = this.model.accomodationUnitTypes
        .filter((x) => !x.id)
        .filter(
          (x) =>
            x.arrivalDate < searchDepartureDate &&
            searchArrivalDate < x.departureDate
        )
        .map((x) => {
          return {
            accomodationUnitTypeId: x.accomodationUnitTypeId,
            accomodationUnitId: x.accomodationUnitId,
            ratePlanId: x.ratePlan?.id,
            occupancyBasedRuleId: x.occupancyBasedRuleId,
            numberOfOccupants: x.allowedOccupancy,
          };
        });
    }

    return toReturn;
  }

  get freedAvailabilities() {
    let toReturn = [] as SelectedAvailability[];
    const searchArrivalDate = this.model?.arrivalDate
      ?.toISOString()
      .substring(0, 10);
    const searchDepartureDate = this.model?.departureDate
      ?.toISOString()
      .substring(0, 10);

    if (!searchArrivalDate || !searchDepartureDate || !this.model) {
      return toReturn;
    }

    if (this.model) {
      toReturn = this.model.originalUnitTypesReservationWasOpenedWith
        .filter(
          (x) => !this.model?.accomodationUnitTypes.some((ut) => ut.id == x.id)
        )
        .filter(
          (x) =>
            x.arrivalDate < searchDepartureDate &&
            searchArrivalDate < x.departureDate
        )
        .map((x) => {
          return {
            accomodationUnitTypeId: x.accomodationUnitTypeId,
            accomodationUnitId: x.accomodationUnitId,
            ratePlanId: x.ratePlan?.id,
            occupancyBasedRuleId: x.occupancyBasedRuleId,
            numberOfOccupants: x.allowedOccupancy,
          };
        });
    }

    return toReturn;
  }

  addSelectedUnits(selection: SimpleAvailabilitySearchResult[]) {
    const ratePlanId =
      (this.model?.accomodationUnitTypes.length ?? 0) > 0
        ? this.model?.accomodationUnitTypes[0]?.ratePlan?.id
        : undefined;
    const ratePlanAccomodationUnitTypeId =
      (this.model?.accomodationUnitTypes.length ?? 0) > 0
        ? this.model?.accomodationUnitTypes[0]?.ratePlan
            ?.ratePlansAccomodationUnitTypeId
        : undefined;
    const availabilities = [] as SelectedAvailability[];
    selection.forEach((x) => {
      availabilities.push({
        accomodationUnitTypeId: x.accommodationUnitTypeId,
        ratePlanId: ratePlanId,
        ratePlansAccomodationUnitTypeId: ratePlanAccomodationUnitTypeId,
        occupancyBasedRuleId: undefined,
        accomodationUnitId: x.accommodationUnitId,
      } as SelectedAvailability);
    });
    const restrictions: SearchRestrictionsModel = {
      period: [],
      numberOfUnits: selection.length,
      numberOfAdults: this.availabilitySearchPrefil.numberOfAdults,
      numberOfChildren: this.availabilitySearchPrefil.numberOfChildren,
      childrenAges: this.availabilitySearchPrefil.childrenAges,
      isFromCalendar: false,
    };

    this.addAvailabilities(availabilities, restrictions);
  }

  availabilitySearchSelection = [] as SelectedAvailability[];
  availabilitySearchRestrictions: SearchRestrictionsModel | null = null;

  availabilitySearchOpen = false;
  // add selected availabilities as units
  addAvailabilities(
    availabilities: SelectedAvailability[],
    restrictions?: SearchRestrictionsModel
  ) {
    const requestModel: AddUnitModel[] = availabilities.map((x) => {
      return {
        accomodationUnitTypeId: x.accomodationUnitTypeId,
        ratePlanId: x.ratePlanId,
        ratePlansAccomodationUnitTypeId: x.ratePlansAccomodationUnitTypeId,
        accomodationUnitId: x.accomodationUnitId,
        distributionChannelTypeId:
          this.model?.distributionChannelTypeId ?? null,
        channelId:
          this.model?.distributionChannelTypeId ==
          DistributionChannelTypesEnum.PartnerAgency
            ? this.model.salesChannelId
            : this.model?.distributionChannelTypeId ==
              DistributionChannelTypesEnum.OTA
            ? this.model.otaid
            : null,
        currencyId:
          (this.model?.accomodationUnitTypes.length ?? 0) > 0
            ? this.model?.accomodationUnitTypes[0].ratePlan?.currencyId ?? null
            : null,
        arrivalDate:
          this.restrictions?.period[0] ?? this.model?.arrivalDate ?? null,
        departureDate:
          this.restrictions?.period[1] ?? this.model?.departureDate ?? null,
      };
    });

    this.$emit("isLoadingChanged", true);
    Vue.axios
      .post<ReservationAccUnitModel[]>(
        "reservations/GetUnitsForReservationForm",
        { units: requestModel }
      )
      .then((res) => {
        const numberOfAddedUnits = res.data.length;
        let totalAdults =
          restrictions?.numberOfAdults ??
          this.restrictions?.numberOfAdults ??
          0;
        const totalChildren =
          restrictions?.numberOfChildren ??
          this.restrictions?.numberOfChildren ??
          0;
        let assignedChildrenAges = 0;

        if (
          this.model &&
          this.model.numberOfUnits == this.model.accomodationUnitTypes.length
        ) {
          this.model.numberOfUnits =
            (this.model.numberOfUnits ?? 0) + numberOfAddedUnits;
        }

        for (const unit of res.data.sort((a, b) =>
          !a.ratePlan?.isDefault && b.ratePlan?.isDefault
            ? 1
            : a.ratePlan?.isDefault && !b.ratePlan?.isDefault
            ? -1
            : (a.ratePlan?.minPersons ?? 0) > (b.ratePlan?.minPersons ?? 0)
            ? 1
            : (a.ratePlan?.minPersons ?? 0) < (b.ratePlan?.minPersons ?? 0)
            ? -1
            : 0
        )) {
          const toAdd = {
            ...new ReservationAccUnitModel(),
            ...unit,
          };

          if (restrictions?.period && restrictions.period.length > 0) {
            toAdd.arrivalDate = restrictions.period[0]
              .toISOString()
              .substring(0, 10);
            toAdd.departureDate = restrictions.period[1]
              .toISOString()
              .substring(0, 10);
            toAdd.numberOfNights = differenceInDays(
              restrictions?.period[0],
              restrictions?.period[1]
            );
          } else if (this.model?.arrivalDate && this.model?.departureDate) {
            toAdd.arrivalDate = this.model.arrivalDate
              .toISOString()
              .substring(0, 10);
            toAdd.departureDate = this.model.departureDate
              .toISOString()
              .substring(0, 10);
            toAdd.numberOfNights = differenceInDays(
              new Date(this.model.arrivalDate),
              new Date(this.model.departureDate)
            );
          }

          if (toAdd.ratePlan?.isDefault) {
            const numOfPersonsToAssign =
              (toAdd.ratePlan.maxPersons ?? 0) > totalAdults
                ? totalAdults
                : toAdd.ratePlan.maxPersons ?? 0;
            toAdd.numberOfAdults = numOfPersonsToAssign;
            totalAdults = totalAdults - numOfPersonsToAssign;
          } else {
            toAdd.numberOfAdults = Math.floor(totalAdults / numberOfAddedUnits);
          }
          toAdd.numberOfChildren = Math.floor(
            totalChildren / numberOfAddedUnits
          );

          let childrenAges = [] as number[];

          const currentRestrictions = restrictions ?? this.restrictions;
          //if from availability search - copy children ages
          //if from new reservation - children ages will be "defined" but empty so check for length
          if (
            currentRestrictions?.childrenAges != undefined &&
            currentRestrictions.childrenAges.length ==
              currentRestrictions.numberOfChildren
          ) {
            childrenAges = currentRestrictions.childrenAges;
          }
          //from reservation form - create new 'empty' array for number of allocated children to added unit
          else {
            childrenAges = Array.from(Array(totalChildren), () => 0);
          }

          toAdd.childrenAges = _.cloneDeep(
            childrenAges.slice(
              assignedChildrenAges,
              assignedChildrenAges + toAdd.numberOfChildren
            )
          );
          assignedChildrenAges += toAdd.childrenAges.length;

          // some guests might be left floating around due to rounding, assign them to the last unit
          if (unit === res.data[res.data.length - 1]) {
            const leftoverAdults = totalAdults % numberOfAddedUnits;
            const leftoverChildren = totalChildren % numberOfAddedUnits;
            const leftoverChildrenAges = childrenAges.slice(
              assignedChildrenAges,
              assignedChildrenAges + leftoverChildren
            );

            toAdd.numberOfAdults += leftoverAdults;
            toAdd.numberOfChildren += leftoverChildren;
            toAdd.childrenAges.push(..._.cloneDeep(leftoverChildrenAges));
            assignedChildrenAges += leftoverChildrenAges.length;
          }

          const additionalServicesToAdd: AddOnServiceModel[] = [];
          for (const service of toAdd.selectedServices) {
            if (service.periods && service.periods.length != 0) {
              additionalServicesToAdd.push(
                ...service.periods.map((x) => {
                  return {
                    ...service,
                    netUnitPrice: x.amount,
                    from: x.from,
                    to: x.to,
                    periods: [],
                  } as AddOnServiceModel;
                })
              );
            }
          }
          toAdd.selectedServices.push(...additionalServicesToAdd);

          for (const service of toAdd.selectedServices) {
            calculateAddOnServiceQuantity(
              service,
              toAdd,
              this.calculateWithEVisitorDates ?? false
            );

            const discountFactor = round(service.discountPercent / 100, 8) ?? 0;

            const totalGrossPrice = round(
              service.grossUnitPrice * service.decimalQuantity,
              2
            );
            service.grossPrice = round(
              totalGrossPrice * (1 - discountFactor),
              2
            );
          }

          const temp = _.clone(
            toAdd.selectedServices.filter((x) => x.isCityTax)
          );
          for (const service of temp) {
            if (service.to && service.from && service.decimalQuantity === 0) {
              toAdd.selectedServices = toAdd.selectedServices.filter(
                (x) => !_.isEqual(service, x)
              );
            } else if (
              !service.to &&
              !service.from &&
              service.decimalQuantity === 0 &&
              toAdd.selectedServices.some(
                (x) =>
                  x.addOnServiceId === service.addOnServiceId &&
                  x.decimalQuantity != 0
              )
            ) {
              toAdd.selectedServices = toAdd.selectedServices.filter(
                (x) => !_.isEqual(service, x)
              );
            }
          }
          this.model?.accomodationUnitTypes.push(toAdd);
          this.changeCustomerForCalendarRatePlan();
        }
      })
      .finally(() => {
        this.$emit("isLoadingChanged", false);
      });
    this.availabilitySearchOpen = false;
  }

  stayPeriodChanged() {
    this.$emit("stayPeriodChanged");
  }
  // check availability of units
  checkAvailability() {
    if (
      this.model &&
      this.model.accomodationUnitTypes &&
      this.model.accomodationUnitTypes.length > 0
    ) {
      this.isNotAvailable = [];
      const ids = this.model.accomodationUnitTypes.filter(
        (value, index, self) =>
          self
            .map((x) => x.accomodationUnitTypeId)
            .indexOf(value.accomodationUnitTypeId) === index
      );
      const requestModel = {
        arrivalDate: [] as Date[],
        departureDate: [] as Date[],
        accomodationUnitTypes: [] as UnitAvailability[],
      };

      for (const unitType of ids) {
        if (unitType.accomodationUnitId) {
          const tempArrival = new Date(unitType.arrivalDate);
          const tempDeparture = new Date(unitType.departureDate);
          const arrival = new Date(
            Date.UTC(
              tempArrival.getFullYear(),
              tempArrival.getMonth(),
              tempArrival.getDate()
            )
          );
          const departure = new Date(
            Date.UTC(
              tempDeparture.getFullYear(),
              tempDeparture.getMonth(),
              tempDeparture.getDate()
            )
          );
          requestModel.arrivalDate.push(arrival);
          requestModel.departureDate.push(departure);
          requestModel.accomodationUnitTypes.push({
            accomodationUnitTypeId: unitType.accomodationUnitTypeId,
            numberOfSelectedUnits: this.model.accomodationUnitTypes.filter(
              (x) => x.accomodationUnitTypeId == unitType.accomodationUnitTypeId
            ).length,
            numberOfAvailableUnits: 0,
          });
        }
      }

      if (
        requestModel.arrivalDate.length == 0 ||
        requestModel.departureDate.length == 0 ||
        requestModel.accomodationUnitTypes.length == 0
      ) {
        return;
      }

      Vue.axios
        .post<UnitAvailability[]>(
          "reservations/CheckUnitTypesAvailability",
          requestModel
        )
        .then((res) => {
          this.unitAvailabilities = res.data;

          this.model?.accomodationUnitTypes.forEach((r) => {
            const availability = this.unitAvailabilities.find(
              (x) => x.accomodationUnitTypeId == r.accomodationUnitTypeId
            );
            if (
              availability &&
              availability.numberOfSelectedUnits >
                availability.numberOfAvailableUnits &&
              r.accomodationUnitId
            ) {
              this.isNotAvailable.push(r.accomodationUnitId);
            }
          });

          this.$emit("notAvailable", this.isNotAvailable);
        });
    }
  }

  checkOverbooking() {
    if (
      this.model &&
      this.model.accomodationUnitTypes &&
      this.model.accomodationUnitTypes.length > 0
    ) {
      const requestModel = {
        arrivalDate: [] as Date[],
        departureDate: [] as Date[],
        accommodationUnitIds: [] as number[],
        reservationId: this.model.id,
      };

      for (const unitType of this.model.accomodationUnitTypes) {
        if (unitType.accomodationUnitId) {
          const tempArrival = new Date(unitType.arrivalDate);
          const tempDeparture = new Date(unitType.departureDate);
          const arrival = new Date(
            Date.UTC(
              tempArrival.getFullYear(),
              tempArrival.getMonth(),
              tempArrival.getDate()
            )
          );
          const departure = new Date(
            Date.UTC(
              tempDeparture.getFullYear(),
              tempDeparture.getMonth(),
              tempDeparture.getDate()
            )
          );
          requestModel.arrivalDate.push(arrival);
          requestModel.departureDate.push(departure);
          requestModel.accommodationUnitIds.push(unitType.accomodationUnitId);
        }
      }

      if (
        requestModel.arrivalDate.length == 0 ||
        requestModel.departureDate.length == 0 ||
        requestModel.accommodationUnitIds.length == 0
      ) {
        return;
      }

      Vue.axios
        .post<number[]>(
          "reservations/CheckAccommodationUnitOverbooking",
          requestModel
        )
        .then((res) => {
          this.isOverbooked = res.data as number[];

          this.$emit("overbooked", this.isOverbooked);
        });
    }
  }

  // get day prices for units
  getUnitsDayPrices() {
    if (
      this.model &&
      this.model.accomodationUnitTypes &&
      this.model.accomodationUnitTypes.length > 0
    ) {
      const ids = this.model.accomodationUnitTypes
        .map((x) => x.accomodationUnitTypeId)
        .filter(this.getDistinct);

      const arrivalDates =
        this.model.accomodationUnitTypes
          .map((x) => x.arrivalDate)
          .filter((x: any) => x) ?? [];

      const departureDates =
        this.model.accomodationUnitTypes
          .map((x) => x.departureDate)
          .filter((x: any) => x) ?? [];

      const minArrivalDate = arrivalDates.sort()[0];
      const maxDepartureDate = departureDates.sort().reverse()[0];

      const requestModel = {
        arrivalDate: minArrivalDate,
        departureDate: maxDepartureDate,
        accomodationUnitTypesIds: ids,
      };

      Vue.axios
        .post("reservations/GetUnitsDayPrices", requestModel)
        .then((res) => {
          if (this.model) {
            if (!policyChecker("OWNER_LEVEL_3")(this.claims)) {
              for (const unit of this.model.accomodationUnitTypes) {
                for (const ratePlan of unit.ratePlanOptions) {
                  const ratePlanPrices = res.data
                    .find(
                      (x: any) =>
                        x.accomodationUnitTypeId === unit.accomodationUnitTypeId
                    )
                    ?.ratePlanPrices.find(
                      (x: any) => x.ratePlanAccUnitTypeId === ratePlan.id
                    );

                  ratePlan.dayPrices =
                    ratePlanPrices?.dayPrices.filter(
                      (x: any) =>
                        (Date.parse(x.date.substring(0, 10)) >=
                          Date.parse(unit.arrivalDate.substring(0, 10)) &&
                          Date.parse(x.date.substring(0, 10)) <
                            Date.parse(unit.departureDate.substring(0, 10))) ||
                        (Date.parse(x.date.substring(0, 10)) ==
                          Date.parse(unit.arrivalDate.substring(0, 10)) &&
                          Date.parse(x.date.substring(0, 10)) ==
                            Date.parse(unit.departureDate.substring(0, 10)))
                    ) ?? [];

                  if (
                    unit.ratePlan?.ratePlansAccomodationUnitTypeId ===
                    ratePlan.id
                  ) {
                    const currentPrices = _.cloneDeep(unit.dayPrices);
                    const isDayStay = unit.arrivalDate == unit.departureDate;
                    const isServiceTypeDayStay =
                      _.first(currentPrices)?.serviceTypeId ==
                      _.first(this.serviceTypes?.filter((x) => x.isDayRest))
                        ?.id;

                    // set serviceType to one from current prices or to ratePlans default serviceType for new units
                    const currentServiceTypeId =
                      isDayStay && !isServiceTypeDayStay
                        ? _.first(this.serviceTypes?.filter((x) => x.isDayRest))
                            ?.id
                        : !isDayStay && isServiceTypeDayStay
                        ? ratePlan.defaultServiceTypeId
                        : _.first(currentPrices)?.serviceTypeId ??
                          ratePlan.defaultServiceTypeId;

                    const currentPriceIncludeCityTax =
                      this.serviceTypes?.find(
                        (x) => x.id == currentServiceTypeId
                      )?.includesCityTax ?? false;

                    unit.dayPrices = _.cloneDeep(ratePlan?.dayPrices ?? []);

                    // if user has set pricePerNight manually we still need to fetch prices in case stay period was changed
                    // after which we set all day prices to user set value
                    if (unit.userSetPricePerNightManually) {
                      unit.dayPrices.forEach(
                        (x) => (
                          (x.price =
                            (unit.pricePerNight ?? x.price) -
                            this.mergedCityTaxPricePerDay(
                              unit,
                              currentPriceIncludeCityTax
                            )),
                          (x.mergedCityTaxAmount =
                            this.mergedCityTaxPricePerDay(
                              unit,
                              currentPriceIncludeCityTax
                            )),
                          (x.serviceTypeId = currentServiceTypeId)
                        )
                      );
                    }
                    // If none of the above is triggered we still need to
                    // set new price and merged amount
                    else {
                      unit.dayPrices.forEach(
                        (x) => (
                          (x.price =
                            x.price -
                            this.mergedCityTaxPricePerDay(
                              unit,
                              currentPriceIncludeCityTax
                            )),
                          (x.mergedCityTaxAmount =
                            this.mergedCityTaxPricePerDay(
                              unit,
                              currentPriceIncludeCityTax
                            )),
                          (x.serviceTypeId = currentServiceTypeId)
                        )
                      );
                    }

                    // only change unsaved prices (eg, when extending a stay for 1 day, only update the price for that 1 day)
                    currentPrices.forEach((e: any) => {
                      e.serviceTypeId =
                        !isDayStay && isServiceTypeDayStay
                          ? currentServiceTypeId
                          : isDayStay && !isServiceTypeDayStay
                          ? currentServiceTypeId
                          : e.serviceTypeId;
                      e.mergedCityTaxAmount = this.mergedCityTaxPricePerDay(
                        unit,
                        currentPriceIncludeCityTax
                      );
                    });
                    const pricesToSet: {
                      date: Date;
                      price: number;
                      inputPrice: number;
                      inputPriceBeforeCommission: number;
                      serviceTypeId?: number;
                      mergedCityTaxAmount: number;
                    }[] = [];
                    unit.dayPrices.forEach((e: any) =>
                      pricesToSet.push(
                        currentPrices?.find((x) => x.date == e.date) ?? e
                      )
                    );

                    unit.dayPrices = _.cloneDeep(pricesToSet);

                    if (!unit.userSetPricePerNightManually) {
                      unit.pricePerNight = round(
                        round(
                          unit.dayPrices.reduce(
                            (sum, dprice) =>
                              sum +
                              dprice.price +
                              this.mergedCityTaxPricePerDay(
                                unit,
                                currentPriceIncludeCityTax
                              ),
                            0
                          ) ?? 0
                        ) / (unit.dayPrices.length ?? 1),
                        2
                      );
                    }
                  }
                }
              }
            } else {
              for (const unit of this.model.accomodationUnitTypes) {
                const accUnitType = res.data.find(
                  (x: any) =>
                    x.accomodationUnitTypeId == unit.accomodationUnitTypeId
                );
                const currentPrices = _.cloneDeep(unit.dayPrices);
                unit.dayPrices = _.cloneDeep(
                  accUnitType.ratePlanPrices[0].dayPrices ?? []
                );
                if (unit.userSetPricePerNightManually) {
                  unit.dayPrices.forEach(
                    (x) => (
                      (x.price =
                        (unit.pricePerNight ?? x.price) -
                        this.mergedCityTaxPricePerDay(unit, false)),
                      (x.mergedCityTaxAmount = this.mergedCityTaxPricePerDay(
                        unit,
                        false
                      ))
                    )
                  );
                }
                // If none of the above is triggered we still need to
                // set new price and merged amount
                else {
                  unit.dayPrices.forEach(
                    (x) => (
                      (x.price =
                        x.price - this.mergedCityTaxPricePerDay(unit, false)),
                      (x.mergedCityTaxAmount = this.mergedCityTaxPricePerDay(
                        unit,
                        false
                      ))
                    )
                  );
                }
                const pricesToSet: {
                  date: Date;
                  price: number;
                  inputPrice: number;
                  inputPriceBeforeCommission: number;
                  serviceTypeId?: number;
                  mergedCityTaxAmount: number;
                }[] = [];
                unit.dayPrices.forEach((e: any) =>
                  pricesToSet.push(
                    currentPrices.find((x) => x.date == e.date) ?? e
                  )
                );

                unit.dayPrices = _.cloneDeep(pricesToSet);

                if (!unit.userSetPricePerNightManually) {
                  unit.pricePerNight = round(
                    round(
                      unit.dayPrices.reduce(
                        (sum, dprice) =>
                          sum +
                          dprice.price +
                          this.mergedCityTaxPricePerDay(unit, false),
                        0
                      ) ?? 0
                    ) / (unit.dayPrices.length ?? 1)
                  );
                }
              }
            }
            for (const resAccUnitType of this.model?.accomodationUnitTypes) {
              if (resAccUnitType.id && resAccUnitType.id === 0)
                this.recalculateAgencyFees(resAccUnitType);
            }
          }
        });
    }
  }

  recalculateAgencyFees(item: ReservationAccUnitModel) {
    item.appliedAgencyFees = [];
    for (const fee of item.propertyAgencyFees) {
      item.appliedAgencyFees.push(calculateAgencyFees(fee, item));
    }
    item.agencyFeesTotal = item.appliedAgencyFees?.reduce(
      (sum, x) => sum + (x.amount ?? 0),
      0
    );
  }
  // includesCityTax is passed because new prices dont have a serviceType defined so we use current prices
  mergedCityTaxPricePerDay(
    unit: ReservationAccUnitModel,
    includesCityTax: boolean
  ) {
    const currencyId =
      unit.ratePlan?.currencyId ?? this.financialSettings?.workingCurrency.id;
    let totalCityTaxPrice = 0;
    if (unit && unit.selectedServices) {
      totalCityTaxPrice = unit.selectedServices
        .filter((x) => x.isCityTax)
        .reduce(
          (sum, e) =>
            includesCityTax
              ? sum +
                (this.currencyConversionService?.convertCurrency(
                  e.grossPrice,
                  e.currencyId,
                  currencyId ?? e.currencyId
                ) ?? e.grossPrice)
              : sum,
          0
        );
    }

    return round(
      totalCityTaxPrice /
        (this.numberOfNights(unit) > 0 ? this.numberOfNights(unit) : 1),
      2
    );
  }

  numberOfNights(unit: ReservationAccUnitModel) {
    if (unit.arrivalDate && unit.departureDate) {
      return differenceInDays(
        new Date(unit.arrivalDate),
        new Date(unit.departureDate)
      );
    } else {
      return 0;
    }
  }

  getDistinct(value: any, index: any, self: any) {
    return self.indexOf(value) === index;
  }

  get canAddUnits() {
    return (
      (this.model?.numberOfUnits ?? 0) >
      (this.model?.accomodationUnitTypes.length ?? 0)
    );
  }

  openCopyGuestsDialog(unitId: number) {
    this.copyGuestsToUnitId = unitId;
    this.copyGuestsOpen = true;
  }

  clearRestrictions() {
    if (this.restrictions) {
      this.restrictions.isFromAvailabilitySearch = false;
      this.restrictions.isFromCalendar = false;
    }
  }

  // codebooks
  @Action("codebooks/refreshPriceCalculationMethods")
  refreshPriceCalculationMethods?: () => Promise<void>;
  @Getter("codebooks/priceCalculationMethods")
  priceCalculationMethods?: PriceCalculationMethodView[];
  @Action("codebooks/refreshTaxRates")
  refreshTaxRates?: () => Promise<void>;
  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];
  @Action("codebooks/refreshSalesChannels")
  refreshSalesChannels?: () => Promise<void>;
  @Getter("codebooks/salesChannels") salesChannels?: SalesChannelView[];
  @Action("codebooks/refreshServiceTypes")
  refreshServiceTypes?: () => Promise<void>;
  @Getter("codebooks/serviceTypes")
  serviceTypes?: ServiceType[];
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;
  @Getter("financial/settings") financialSettings?: FinancialSettingsType;

  @Action("codebooks/refreshAccomodationUnitStatuses")
  refreshAccomodationUnitStatuses?: () => Promise<void>;
  @Getter("codebooks/accomodationUnitStatuses")
  accomodationUnitStatuses?: AccomodationUnitStatus[];

  @Getter("appParams/childrenAffectPAXRatePlanSelection")
  childrenAffectPAXRatePlanSelection?: boolean;
}
